<template>
    <div class="resources-data">
        <div class="sizer" ref="sizer">
            <div class="item">
                <el-select v-model="area_id" placeholder="选择区" @change="getStreet" clearable filterable>
                    <el-option
                    v-for="item in areaData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <el-select v-model="street_id" placeholder="选择镇/街道" @change="getSchool" clearable filterable>
                    <el-option
                    v-for="item in streetData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <el-select v-model="school_id" placeholder="选择学校" clearable filterable>
                    <el-option
                    v-for="item in schoolData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <el-date-picker
                    v-model="data_value"
                    type="daterange"
                    start-placeholder="起始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
            </div>
            <div class="item"><el-button type="primary" @click="screen">筛选</el-button></div>
            <div class="item"><el-button type="primary" @click="reset">重置</el-button></div>
        </div>
        <main>
            <div class="count"> 
                <div class="count-l">
                    <div class="col">
                        <div class="item">
                            <div class="title">总资源数</div>
                            <div class="inner">
                                <div class="inner-l"><span class="num">{{resourcesData.total_num}}</span></div>
                                <div class="inner-r"><i class="fs10"></i></div>  
                            </div> 
                        </div>
                        <div class="count-child">
                            <div class="count-child-item">
                                <div class="title">学科资源</div>
                                <div class="num">{{resourcesData.resource_num}}</div>
                            </div>
                            <div class="count-child-item">
                                <div class="title">视频资源类</div>
                                <div class="num">{{resourcesData.video_num}}</div>
                            </div>
                            <div class="count-child-item">
                                <div class="title">试卷试题</div>
                                <div class="num">{{resourcesData.test_num}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="count-r common_main_inner">
                    <div class="count-r-inner">
                        <div class="item circle-1">
                            <div class="title">小学</div>
                            <div class="data">
                                <el-progress type="circle" :width="210" color="#4D8FF8" :stroke-width="25" :percentage="resourcesData.primary_percent"></el-progress>
                                </div>  
                        </div>
                        <div class="item circle-2">
                            <div class="title">初中</div>
                            <div class="data">
                                <el-progress type="circle" :width="210" color="#B6BC24" :stroke-width="25" :percentage="resourcesData.junior_percent"></el-progress>
                                </div>
                        </div>
                        <div class="item circle-3">
                            <div class="title">高中</div>
                            <div class="data">
                                <el-progress type="circle" :width="210" color="#69B72A" :stroke-width="25" :percentage="resourcesData.senior_percent"></el-progress>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="src-down-count common_main_inner">
                <div class="title-box">
                    <p class="head-title">资源下载量</p>
                </div>
                <div class="tabs">
                    <el-button type="primary" plain v-for="(tab, inx) in down_tabs" :key="inx" v-text="tab.text" :class="{'live' : tab.live}" @click="downAdvice(inx)">近1天</el-button>
                </div>
                <div class="data">
                    <div :id="down_line" class="line"></div>
                </div>
            </div>
            <div class="src-up-count">
                <div class="content-left common_main_inner">
                    <div>
                        <div class="title-box">
                            <p class="head-title">资源上传量</p>
                        </div>
                        <div class="tabs">
                            <el-button type="primary" plain v-for="(tab, inx) in upTabs" :key="inx" v-text="tab.text" :class="{'live' : tab.live}" @click="upAdvice(inx)"></el-button>
                        </div>
                        <div class="data">
                            <div :id="upLine" class="line"></div>
                        </div>
                    </div>
                </div>
                <div class="content-right common_main_inner">
                    <div class="title-box">
                        <p class="head-title">其他</p>
                    </div>
                    <div class="icon">
                        <i class="fs11"></i>
                    </div>
                    <div class="item">
                        <div class="name">
                            <span>教师</span>
                            <span>{{otherData.teacher_percent + '%'}}</span>
                        </div>
                        <div class="pro">
                            <el-progress color="#44BE61" :stroke-width="15" :percentage="otherData.teacher_percent" :show-text="false"></el-progress>
                        </div>
                    </div>
                    <div class="item">
                    <div class="name">
                        <span>其他角色</span>
                        <span>{{otherData.other_percent + '%'}}</span>
                    </div>
                    <div class="pro">
                        <el-progress color="#40B4EE" :stroke-width="15" :percentage="otherData.other_percent" :show-text="false"></el-progress>
                    </div>
                    </div>
                    <div class="tips">
                        <p>上方数据为上传资源角色比例</p>
                        <p>数据取自{{otherData.update_time}}</p>
                    </div>
                </div>
            </div>
            <div class="new-up common_main_inner">
                <div class="title-box">
                    <p class="head-title">最新上传资源</p>
                </div>
                <ul class="list">
                    <li  v-for="(item, index) in newUpData" :key="index">
                        <div class="item">
                            <div class="src">
                                <div class="src-inner">
                                    <div class="icon"><img :src="`${BASE_URL}/static/index/images/format/resourceicon${item.file_type}.png`" alt=""></div>
                                    <div class="text">
                                        <div class="name">
                                            <a target="_blank" style="color: #fff" :href="`${BASE_URL}/index/resource/detail?resourceid=` + item.id">{{item.name}}</a>
                                        </div>
                                        <div class="desc"><span>{{item.grade_name}}·{{item.subject_name}}</span><span>上传者：{{item.create_name}}</span></div>
                                    </div>
                                </div>
                            </div>
                            <div class="time"><div>{{getDateDiff(item.create_time)}}</div></div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="up-user common_main_inner">
                <div class="title-box">
                    <p class="head-title">上传TOP榜</p>
                </div>
                <ul class="list">
                    <li  v-for="(item, index) in upUserData" :key="index">
                        <div class="item">
                            <div class="name"><span>{{item.user_name.substring(item.user_name.length-1, item.user_name.length)}}</span>{{item.user_name}}</div>
                            <div class="time">上传数：{{item.upload_num}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </main>
    </div>
</template>
<script>
/**
 * 获取当前时间戳
 */
const now = Date.now || function() {
    return new Date().getTime();
}

export default {
    data() {
        return {
            // 筛选
            area_id: null,
            areaData: [],
            street_id: null,
            streetData: [],
            school_id: null,
            schoolData: [],
            data_value: '',
            // 资源数
            resourcesData: [],
            // 资源下载量
            down_text: [],
            down_time: [],
            down_date: new Date().getTime(),
            downTotal: null,
            downKey: null,
            downPage: 1,
            downData: [],
            down_line: 'src-down-count',
            down_tabs: [
                {
                    text: '近1天',
                    name: '0',
                    live: false
                },
                {
                    text: '近7天',
                    name: '6',
                    live: false
                },
                {
                    text: '近30天',
                    name: '29',
                    live: true
                }
            ],
            // 资源上传量
            up_text: [],
            up_time: [],
            up_date: new Date().getTime(),
            keyTotal: null,
            upkey: null,
            upPage: 1,
            upData: [],
            upLine: 'platform-line',
            upTabs: [
                {
                    text: '近1天',
                    name: '0',
                    live: false
                },
                {
                    text: '近7天',
                    name: '6',
                    live: false
                },
                {
                    text: '近30天',
                    name: '29',
                    live: true
                }
            ],
            // 其他
            otherData: [],
            // 最新上传资源
            newUpData: [],
            // 上传top
            upUserData: [],
        }
    },
    created() { 
    },
    mounted() {
        this.watchScroll();
        this.getArea();
        this.getResources();        
        this.getDown();
        this.getUp();
        this.getOther();
        this.getNewUP();
        this.getUpUser();
    },
    methods: {
        watchScroll() {
            let sizer = document.querySelector('.sizer');
            let scrollHeight = sizer.offsetTop;

            let throttled = this.throttle(() => { /*监听页面滚动事件，控制sizer显示/隐藏*/
                let curScrollTop = 0;
                if(document.documentElement&&document.documentElement.scrollTop){  
                    curScrollTop=document.documentElement.scrollTop;  
                }else if(document.body){  
                    curScrollTop=document.body.scrollTop;  
                }

                if(!sizer) {
                    document.removeEventListener('scroll',()=>{});
                }  
                if(curScrollTop >= scrollHeight) {
                    sizer.classList.add('pf');
                } else {
                    sizer.classList.remove('pf');
                }
            }, 600);

            document.addEventListener('scroll', throttled)
        },
        /**
         * 创建并返回一个像节流阀一样的函数
         * @param {Funtion} func 传入的函数
         * @param {Number} wait 时间间隔 
         * @param {leading: false || trailing: false} options 
         */
        throttle(func, wait, options) {
            let context, args, result;
            let timeout = null;
            let previous = 0;
            if (!options) options = {};
            const later = function() {
            previous = options.leading === false ? 0 : now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
            };
            return function() {
            if (!previous && options.leading === false) previous = now();
            let remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                clearTimeout(timeout);
                timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
            };
        },
        getSchoolId() { // 获取选中学校的id或全部学校
            let school_data = [];

            if (this.school_id) {
                school_data.push(this.school_id);
            } else {
                if (this.street_id || this.area_id) {
                    this.schoolData.forEach( item => {
                        school_data.push(item.id)
                    });
                } else {
                    school_data = null;
                }
            }

            return school_data;
        },
        // 时间戳显示为多少分钟前，多少天前
        getDateTimeStamp (dateStr) {
		    return Date.parse(dateStr.replace(/-/gi,"/"));
		},
		getDateDiff (dateStr) {
		    var publishTime = this.getDateTimeStamp(dateStr)/1000,
		        d_seconds,
		        d_minutes,
		        d_hours,
		        d_days,
		        timeNow = parseInt(new Date().getTime()/1000),
		        d,

		        date = new Date(publishTime*1000),
		        Y = date.getFullYear(),
		        M = date.getMonth() + 1,
		        D = date.getDate(),
		        H = date.getHours(),
		        m = date.getMinutes(),
		        s = date.getSeconds();
		        //小于10的在前面补0
		        if (M < 10) {
		            M = '0' + M;
		        }
		        if (D < 10) {
		            D = '0' + D;
		        }
		        if (H < 10) {
		            H = '0' + H;
		        }
		        if (m < 10) {
		            m = '0' + m;
		        }
		        if (s < 10) {
		            s = '0' + s;
		        }

		    d = timeNow - publishTime;
		    d_days = parseInt(d/86400);
		    d_hours = parseInt(d/3600);
		    d_minutes = parseInt(d/60);
		    d_seconds = parseInt(d);

		    if(d_days > 0 && d_days < 3){
		        return d_days + '天前';
		    }else if(d_days <= 0 && d_hours > 0){
		        return d_hours + '小时前';
		    }else if(d_hours <= 0 && d_minutes > 0){
		        return d_minutes + '分钟前';
		    }else if (d_seconds < 60) {
		        if (d_seconds <= 0) {
		            return '刚刚发表';
		        }else {
		            return d_seconds + '秒前';
		        }
		    }else if (d_days >= 3 && d_days < 30){
		        return M + '-' + D;
		    }else if (d_days >= 30) {
		        return M + '-' + D;
		    }
		},
        // 初始化
        getArea() {
            /*获取地区 */
            const success = res => {
                this.areaData = res.data.children;
            };
            this.$ajax.get("api/level/get_tree", { params: {}, func: { success: success } });
        },
        getStreet(val) {
            this.streetData = [];
            this.street_id = null;

            this.areaData.forEach(item => {
                if (item.id === val) {
                    this.streetData = item.children;
                }
            })

            this.getSchool(val);
        },
        getSchool(val) {
            this.school_id = null;
            this.schoolData = [];

            if (!val) {
                val = this.area_id;
            }

            let params = {
                id: val
            };
            const success = res => {
                this.schoolData = res.data;
            };
            this.$ajax.get("api/level/get_school_by_postionid", {
                params: params,
                func: { success: success }
            });
        },
        // 筛选
        screen() {
            this.getResources();
            this.downAdvice(-1, 'screen');
            this.upAdvice(-1, 'screen');
            this.getOther();
            this.getNewUP();
            this.getUpUser();
        },
        reset() {
            this.area_id = null;
            this.street_id = null,
            this.streetData = [];
            this.school_id = null;
            this.schoolData = [];
            this.data_value = '';

            this.getResources();
            this.downAdvice(2);
            this.upAdvice(2);
            this.getOther();
            this.getNewUP();
            this.getUpUser();
        },
        // 资源数
        getResources() {
            let success = ( res => {
                this.resourcesData = res.data;
            });
            let fail = (res => {
                this.$message.error(res.msg);
            })

            let params = {
                platform_id: this.getSchoolId(),
                start_time: this.data_value ? this.data_value[0] : null,
                end_time: this.data_value ? this.data_value[1] : null
            }
            this.$ajax.get('api/bigdata/resource_rescount', {params: params, func: {success: success, fail: fail}})
        },
        // 获取日期
        getTodayDate(key) {
            //获取当前时间
            let date = null;
            if (key) {
                date = new Date(new Date() - 1000 * 60 * 60 * 24 * key);
            } else {
                date = new Date();
            }
            
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) {
                month = "0" + month;
            }
            if (day < 10) {
                day = "0" + day;
            }
            let nowDate = year + "-" + month + "-" + day;
            return nowDate;
        },
        // 资源下载量
        getDown(key) {
            let success = ( res => {
                this.downKey = key ? key : '29';
                this.downTotal = res.data.total_page;
                this.downPage = 1;
                this.downData = [
                    {
                        page: 1,
                        data: res.data.data
                    }
                ];
                this.down_text = [];
                this.down_time = [];

                let tempData = res.data.data;

                for (let key in tempData) {
                    this.down_text.push(tempData[key].time_txt);
                    this.down_time.push(tempData[key].time_value);
                }

                this.downInit();
            });
            let fail = (res => {
                this.$message.error(res.msg);
            })

            let params = {
                start_time: this.data_value ? this.data_value[0] : this.getTodayDate(key ? key : '29'),
                end_time: this.data_value ? this.data_value[1] : this.getTodayDate(),
                page: 1,
                platform_id: this.getSchoolId(),
            }
            this.$ajax.get('api/bigdata/resource_downloaddata', {params: params, func: {success: success, fail: fail}})
        },
        downInit() {
            let _this = this;
            let downChart = this.$echarts.init(document.getElementById(this.down_line));

            downChart.setOption({
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}: {c}"
                },
                grid: {
                    left: 60,
                    right: 60,
                    bottom: 100
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLabel: {
                        interval: 0,
                        color: "#fff",
                        fontSize: "14",
                        rotate: 45
                    },
                    axisLine: {
                        lineStyle: {
                        color: "#585E88"
                        }
                    },
                    data: _this.down_text
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        fontSize: "14",
                        color: "#fff"
                    },
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                        color: "#585E88"
                        }
                    }
                },
                dataZoom: [                    
                    {
                        type: 'slider',
                        show: true,
                        start: 0, // 数据窗口范围的起始百分比。范围是：0 ~ 100
                        end: 50,
                        height: 10, // 组件高度
                        xAxisIndex: [0],
                        backgroundColor: '#314062', // 组件的背景颜色
                        borderColor: '#314062', // 组件边框颜色
                        showDataShadow: false, //是否显示数据阴影 默认auto
                        showDetail: false, //即拖拽时候是否显示详细数值信息 默认true           
                        filterMode: 'filter',
                        fillerColor: new _this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                            {
                                //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
                                //给第一个设置0，第四个设置1，就是垂直渐变
                                offset: 0,
                                color: '#2F81E5'
                            }, 
                            {
                                offset: 1,
                                color: '#2F81E5'
                            }
                        ]),            
                        handleSize: 0, //滑动条的 左右2个滑动条的大小
                        handleColor: '#fff',//h滑动图标的颜色
                        handleStyle: {
                            borderColor: "#fff",
                            borderWidth: "1",
                            shadowBlur: 2,
                            background: "#fff",
                            shadowColor: "#fff",
                        },
                        handleIcon: 'M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z',
                    },
                    {
                        type: 'inside',
                        show: true,
                        xAxisIndex: [0],
                        start: 1,
                        end: 100
                    }
                ],
                series: [
                    {
                        data: _this.down_time,
                        type: "line",
                        smooth: true,
                        itemStyle: {
                            borderColor: "#f7b20a",
                            color: "#f7b20a",
                            borderWidth: 0
                        },
                        lineStyle: {
                            color: "#f7b20a"
                        },
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0.9,
                                x2: 0,
                                y2: 0,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#273757' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#FFB708' // 100% 处的颜色
                                    }
                                ],
                                globalCoord: false // 缺省为 false
                            }
                        }
                    }
                ]
            });

            downChart.on("dataZoom", function(param){
                let opt = downChart.getOption().dataZoom[0];
                let start = opt.start;
                let end = opt.end;
                let flage = _this.downTotal - _this.downPage;
                let tiemFlag = new Date().getTime() - _this.down_date;

                if (end > 60 && flage > 0 && tiemFlag > 500) {
                    _this.down_date = new Date().getTime();

                    let success = ( res => {
                        _this.downData.push({
                            page: res.data.current_page,
                            data: res.data.data
                        });

                        let tLen = _this.down_text.length;
                        _this.down_text = [];
                        _this.down_time = [];

                        _this.downData.sort(function(a, b) {
                            return a.page - b.page;
                        })                        
                        _this.downData.forEach( item => {
                            for (let key in item.data) {
                                _this.down_text.push(item.data[key].time_txt);
                                _this.down_time.push(item.data[key].time_value);
                            }
                        })                        

                        let sLen = start * tLen / _this.down_text.length;
                        let eLen = sLen + 100/ Math.floor(_this.down_text.length / 10);


                        downChart.setOption({
                            dataZoom: [                    
                                {  
                                    start : sLen,
                                    end : eLen,
                                },
                            ],
                            xAxis: {
                                data: _this.down_text
                            },
                            series: [
                                {
                                    data: _this.down_time
                                }
                            ]
                        })
                    });

                    let fail = (res => {
                        _this.$message.error(res.msg);
                    })
                    let params = {
                        start_time: _this.data_value ? _this.data_value[0] : _this.getTodayDate(_this.downKey ? _this.downKey : '29'),
                        end_time: _this.data_value ? _this.data_value[1] : _this.getTodayDate(),
                        page: _this.downPage + 1,
                        platform_id: _this.getSchoolId(),
                    }

                    _this.$ajax.get('api/bigdata/resource_downloaddata', {params: params, func: {success: success, fail: fail}})
                    _this.downPage++;
                }
            });
        },
        downAdvice(inx, key) {
            let flag = '29';
            if (!this.data_value && key == 'screen') {
                inx = 2;
            }

            this.down_tabs.forEach((e, i) => {
                e.live = false;

                if(inx === i && !this.data_value) {
                    e.live = true;
                    flag = e.name;
                }
            })

            this.getDown(flag);
        },
        // 资源上传量
        getUp(key) {
            let success = ( res => {
                this.upkey = key ? key : '29';
                this.keyTotal = res.data.total_page;
                this.upPage = 1;
                this.upData = [
                    {
                        page: 1,
                        data: res.data.data
                    }
                ];
                this.up_text = [];
                this.up_time = [];

                let tempData = res.data.data;

                for (let key in tempData) {
                    this.up_text.push(tempData[key].time_txt);
                    this.up_time.push(tempData[key].time_value);
                }

                this.upInit();
            });
            let fail = (res => {
                this.$message.error(res.msg);
            })

            let params = {
                start_time: this.data_value ? this.data_value[0] : this.getTodayDate(key ? key : '29'),
                end_time: this.data_value ? this.data_value[1] : this.getTodayDate(),
                page: 1,
                platform_id: this.getSchoolId(),
            }
            this.$ajax.get('api/bigdata/resource_uploaddata', {params: params, func: {success: success, fail: fail}})
        },
        upInit() {
            let _this = this;
            let upChart = this.$echarts.init(document.getElementById(_this.upLine));
            
            upChart.setOption({
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}: {c}"
                },
                grid: {
                    left: 60,
                    right: 60,
                    bottom: 100
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLabel: {
                        interval: 0,
                        color: "#fff",
                        fontSize: "14",
                        rotate: 45
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#585E88"
                        }
                    },
                    data: _this.up_text
                },
                yAxis: {
                    type: "value",
                    axisLabel: {
                        fontSize: "14",
                        color: "#fff"
                    },
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#585E88"
                        }
                    }
                },
                dataZoom: [                    
                    {
                        type: 'slider',
                        show: true,
                        start: 0, // 数据窗口范围的起始百分比。范围是：0 ~ 100
                        end: 50,
                        height: 10, // 组件高度
                        xAxisIndex: [0],
                        backgroundColor: '#314062', // 组件的背景颜色
                        borderColor: '#314062', // 组件边框颜色
                        showDataShadow: false, //是否显示数据阴影 默认auto
                        showDetail: false, //即拖拽时候是否显示详细数值信息 默认true           
                        filterMode: 'filter',
                        fillerColor: new _this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                            {
                                //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
                                //给第一个设置0，第四个设置1，就是垂直渐变
                                offset: 0,
                                color: '#2F81E5'
                            }, 
                            {
                                offset: 1,
                                color: '#2F81E5'
                            }
                        ]),            
                        handleSize: 0, //滑动条的 左右2个滑动条的大小
                        handleColor: '#fff',//h滑动图标的颜色
                        handleStyle: {
                            borderColor: "#fff",
                            borderWidth: "1",
                            shadowBlur: 2,
                            background: "#fff",
                            shadowColor: "#fff",
                        },
                        handleIcon: 'M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z',
                    },
                    {
                        type: 'inside',
                        show: true,
                        xAxisIndex: [0],
                        start: 1,
                        end: 100
                    }
                ],
                series: [
                    {
                        data: _this.up_time,
                        type: "line",
                        smooth: true,
                        itemStyle: {
                            borderColor: "#08DBFF",
                            color: "#08DBFF",
                            borderWidth: 0
                        },
                        lineStyle: {
                            color: "#08DBFF"
                        },
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0.9,
                                x2: 0,
                                y2: 0,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#273757' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#08DBFF' // 100% 处的颜色
                                    }
                                ],
                                globalCoord: false // 缺省为 false
                            }
                        }
                    }
                ]
            });

            upChart.on("dataZoom", function(param){
                let opt = upChart.getOption().dataZoom[0];
                let start = opt.start;
                let end = opt.end;
                let flage = _this.keyTotal - _this.upPage;
                let tiemFlag = new Date().getTime() - _this.up_date;

                if (end > 60 && flage > 0 && tiemFlag > 500) {
                    _this.up_date = new Date().getTime();

                    let success = ( res => {
                        _this.upData.push({
                            page: res.data.current_page,
                            data: res.data.data
                        });

                        let tLen = _this.up_text.length;
                        _this.up_text = [];
                        _this.up_time = [];

                        _this.upData.sort(function(a, b) {
                            return a.page - b.page;
                        })                        
                        _this.upData.forEach( item => {
                            for (let key in item.data) {
                                _this.up_text.push(item.data[key].time_txt);
                                _this.up_time.push(item.data[key].time_value);
                            }
                        })                        

                        let sLen = start * tLen / _this.up_text.length;
                        let eLen = sLen + 100/ Math.floor(_this.up_text.length / 10);


                        upChart.setOption({
                            dataZoom: [                    
                                {  
                                    start : sLen,
                                    end : eLen,
                                },
                            ],
                            xAxis: {
                                data: _this.up_text
                            },
                            series: [
                                {
                                    data: _this.up_time
                                }
                            ]
                        })
                    });

                    let fail = (res => {
                        _this.$message.error(res.msg);
                    })
                    let params = {
                        start_time: _this.data_value ? _this.data_value[0] : _this.getTodayDate(_this.upkey ? _this.upkey : '29'),
                        end_time: _this.data_value ? _this.data_value[1] : _this.getTodayDate(),
                        page: _this.upPage + 1,
                        platform_id: _this.getSchoolId(),
                    }

                    _this.$ajax.get('api/bigdata/resource_uploaddata', {params: params, func: {success: success, fail: fail}})
                    _this.upPage++;
                }
            });
        },
        upAdvice(inx, key) {
            let flag = '29';
            if (!this.data_value && key == 'screen') {
                inx = 2;
            }

            this.upTabs.forEach((e,i) => {
                e.live = false;
                if(inx === i && !this.data_value) {
                    e.live = true;
                    flag = e.name;
                }
            })

            this.getUp(flag);
        },
        // 其他
        getOther() {
            let success = ( res => {
                this.otherData = res.data;
                this.otherData.other_percent = parseInt(this.otherData.other_percent);
                this.otherData.teacher_percent = parseInt(this.otherData.teacher_percent);
            });
            let fail = (res => {
                this.$message.error(res.msg);
            })
            let params = {
                platform_id: this.getSchoolId(),
                start_time: this.data_value ? this.data_value[0] : null,
                end_time: this.data_value ? this.data_value[1] : null
            }

            this.$ajax.get('api/bigdata/resource_teachercount', {params: params, func: {success: success, fail: fail}})
        },
        // 最新上传资源
        getNewUP() {
            let success = ( res => {
                this.newUpData = res.data;
            });
            let fail = (res => {
                this.$message.error(res.msg);
            })
            let params = {
                platform_id: this.getSchoolId(),
                start_time: this.data_value ? this.data_value[0] : null,
                end_time: this.data_value ? this.data_value[1] : null
            }

            this.$ajax.get('api/bigdata/resource_latestupdatedata', {params: params, func: {success: success, fail: fail}})
        },
        // 上传top
        getUpUser() {
            let success = ( res => {
                this.upUserData = res.data;
            });
            let fail = (res => {
                this.$message.error(res.msg);
            })
            let params = {
                platform_id: this.getSchoolId(),
                start_time: this.data_value ? this.data_value[0] : null,
                end_time: this.data_value ? this.data_value[1] : null
            }

            this.$ajax.get('api/bigdata/resource_topdata', {params: params, func: {success: success, fail: fail}})
        },
    }
}
</script>
<style lang="scss">
.resources-data {
    main {
        .count {
            display: flex;

            .count-l {
                margin-right: 20px;

                .item {
                    background: #00a4b8;
                    box-sizing: border-box;
                }

                .count-child {
                    .count-child-item {
                        background: #00a4b8;
                    }
                }

                .item {
                    width: 430px;
                    padding: 43px 20px;
                    background: #00a4b8;
                    border-radius: 6px;
                    color: #fff;
                    margin-bottom: 10px;

                    .title {
                        margin-top: -23px;
                        margin-bottom: 13px;
                        font-size: 16px;                        
                    }

                    .inner {
                        display: flex;
                        margin-bottom: 30px;

                        .inner-l {
                            position: relative;
                            flex: 1;

                            .num {
                                position: absolute;
                                font-size: 40px;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }
                        }

                        .inner-r {
                            flex: 0 0 142px;
                            text-align: center;
                        }
                    }
                }

                .count-child {
                    position: relative;
                    width: 430px;

                    .count-child-item {
                        display: inline-block;
                        width: 210px;
                        height: 160px;
                        padding: 20px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        background: #00a4b8;
                        border-radius: 6px;
                        color: #fff;
                        box-sizing: border-box;

                        &:nth-of-type(2n) {
                            margin-right: 0;
                        }

                        &:nth-last-of-type(1),
                        &:nth-last-of-type(2) {
                            margin-bottom: 0;
                        }

                        .title {
                            font-size: 14px;
                        }

                        .num {
                            font-size: 36px;
                            text-align: center;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
            .count-r {
                flex: 1;
                text-align: center;
                background-color: #283656;

                .count-r-inner {
                    box-sizing: border-box;

                    .item {
                        display: inline-block;
                        width: 210px;
                        margin-right: 60px;
                        padding: 0 10px;

                        &:nth-last-of-type(1) {
                            margin-right: 0;
                        }
                        .title {
                            display: inline-block;
                            font-size: 30px;
                            color: #fff;
                            text-align: center;
                            margin-top: 90px;
                            margin-bottom: 60px;
                        }
                    }
                }

                .el-progress--circle svg path:first-of-type {
                    stroke: #314062 !important;
                }

                .circle-1 .el-progress__text {
                    color: #4D8FF8;
                }

                .circle-2 .el-progress__text {
                    color: #B6BC24;
                }

                .circle-3 .el-progress__text {
                    color: #69B72A;
                }
            }

            @media screen and (max-width: 1520px) {
                .count-r {
                    .count-r-inner {
                        .item {
                            margin-right: 0 !important;
                        }
                    }
                }
            }
        }

        .src-down-count {
            position: relative;
            width: 100%;
            height: 620px;
            margin-top: 20px;
            background-color: #283656;

            .tabs {
                padding-right: 70px;
                text-align: right;

                button {
                    background: none;
                    border-color: #E62125;
                    color: #E62125;
                    margin: 0;
                    padding: 7px 25px;
                    border-radius: 0;
                    border-right: 0;

                    &:last-child {
                        border-right: 1px solid #E62125;
                    }
                }

                .live {
                    background: #E62125;
                    color: #fff;
                }
            }

            .data {
                height: 500px;
                margin: 0 20px 0 23px;

                .line {
                    max-width: 100%;
                    height: 100%;
                }
            }
        }
        
        .new-up {
            .list {
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                li {
                    display: inline-block;
                    padding: 0 20px 0 28px;
                    width: 33.3%;
                    height: 62px;
                    line-height: 62px;
                    border-right: 1px solid #4B5B7F;
                    border-bottom: 1px solid #4B5B7F;
                    box-sizing: border-box;

                    &:nth-of-type(3n) {
                        border-right: 0;
                    }

                    .item {
                        display: flex;

                        .src {
                            flex: 1;

                            .src-inner {
                                display: flex;
                                width: 100%;
                                height: 52px;
                                margin-top: 5px;
                                line-height: 1.5;

                                .icon {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    flex: 0 0 42px;
                                    margin-right: 15px;

                                    img {
                                        width: 100%;
                                        vertical-align: middle;
                                    }
                                }

                                .text {
                                    flex: 1;
                                    color: #fff;

                                    .name {
                                        font-size: 14px;
                                    }

                                    .desc {
                                        padding-top: 5px;
                                        font-size: 12px;

                                        span {
                                            margin-right: 6px;
                                            &:nth-last-of-type(1) {
                                                margin-right: 0;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .time {
                            flex: 0 0 64px;
                            font-size: 12px;
                            color: #6B82B4;
                        }
                    }
                }
            }
        }
    }
}
</style>
